import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import { PositionEntity } from 'src/entities/PositionEntity';

type Props = {
  positions: PositionEntity[];
  /**
   * 取得が終わっているか。false のあいだは寄せない。
   * 取得途中で寄せると、その時点で届いていた一部の点だけを含む範囲で固定され、
   * 残りの案件が画面外に残る（一度きりの fit なので寄せ直さない）。
   */
  isReady?: boolean;
};

/**
 * MapContainer の子として置く不可視コンポーネント。
 * 取得完了後に一度だけ描画物の全点を含む bounds へフィットし、以降はユーザーの
 * パン/ズームを保持する（データ変化で再フィットしない）。
 */
const MapFitBounds = ({ positions, isReady = true }: Props) => {
  const map = useMap();
  const fittedRef = useRef(false);

  useEffect(() => {
    if (fittedRef.current) return;
    if (!isReady) return;
    if (positions.length === 0) return;
    map.fitBounds(positions, { animate: false });
    fittedRef.current = true;
  }, [map, positions, isReady]);

  return null;
};

export default MapFitBounds;
